


import React, { useEffect, useRef, useState } from "react";
import { FaBars, FaChevronLeft } from "react-icons/fa";
import { ReactComponent as TopBarMessageIcon } from "../assets/icons/message1.svg";
import { CoinIcon, TrustIcon } from "./icons";
import { useLanguage } from "../i18n/LanguageProvider";

export default function TopBar({
  onBack,
  onMenu,
  profile,
  centerTitle,
  leftShift = 0,
  backShift = 0,
  notificationsOpen,
  onOpenNotifications,
  onCloseNotifications,
}) {
const { t } = useLanguage();
  

const unreadNotifications = Number(profile?.unreadNotifications || 0);
const hasRealCoins = profile?.coins !== undefined && profile?.coins !== null;
const realCoins = Number(profile?.coins || 0);

const [displayCoins, setDisplayCoins] = useState(0);
const animationRef = useRef(null);
const hasInitializedCoinsRef = useRef(false);
const previousCoinsRef = useRef(0);
const hasBackButton = typeof onBack === "function";
const hasMenuButton = !hasBackButton && typeof onMenu === "function";

useEffect(() => {
  if (!hasRealCoins) return;

  if (!hasInitializedCoinsRef.current) {
    hasInitializedCoinsRef.current = true;
    previousCoinsRef.current = realCoins;
    setDisplayCoins(realCoins);
    return;
  }

  if (animationRef.current) {
    clearInterval(animationRef.current);
    animationRef.current = null;
  }

  const previousCoins = previousCoinsRef.current;

  if (realCoins === previousCoins) {
    setDisplayCoins(realCoins);
    return;
  }

  if (realCoins < previousCoins) {
    previousCoinsRef.current = realCoins;
    setDisplayCoins(realCoins);
    return;
  }

  previousCoinsRef.current = realCoins;

  animationRef.current = setInterval(() => {
    setDisplayCoins((prev) => {
      const remaining = realCoins - prev;

      if (remaining <= 0) {
        clearInterval(animationRef.current);
        animationRef.current = null;
        return realCoins;
      }

      let step = 1;
      if (remaining >= 200) step = 12;
      else if (remaining >= 100) step = 8;
      else if (remaining >= 50) step = 5;
      else if (remaining >= 20) step = 3;
      else if (remaining >= 10) step = 2;

      const next = prev + step;
      return next >= realCoins ? realCoins : next;
    });
  }, 25);

  return () => {
    if (animationRef.current) {
      clearInterval(animationRef.current);
      animationRef.current = null;
    }
  };
}, [hasRealCoins, realCoins]);

const pillBaseStyle = {
  display: "flex",
  alignItems: "center",
  gap: hasBackButton ? "3px" : "5px",
  padding: hasBackButton ? "5px 6px" : "6px 8px",
  borderRadius: "30px",
  border: "1px solid rgba(255,255,255,0.12)",
  background:
    "linear-gradient(135deg, rgba(255,0,127,0.34) 0%, rgba(122,43,255,0.32) 100%)",
  boxShadow:
    "0 10px 24px rgba(0,0,0,0.22), 0 0 18px rgba(255,0,127,0.10), inset 0 1px 0 rgba(255,255,255,0.18)",
  color: "#fff",
  fontFamily: "'Cooper Hewitt', system-ui, -apple-system, Arial, sans-serif",
  fontWeight: 900,
  fontSize: hasBackButton ? "11px" : "12px",
  lineHeight: 1,
  minHeight: hasBackButton ? 34 : 36,
  minWidth: 0,
  boxSizing: "border-box",
  position: "relative",
  overflow: "hidden",
};

const pillIconStyle = {
  fontSize: hasBackButton ? "13px" : "14px",
  lineHeight: 1,
  filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.28))",
};

const pillValueStyle = {
  lineHeight: 1,
  textShadow: "0 1px 6px rgba(0,0,0,0.24)",
};

const pillTextWrapStyle = {
  display: "grid",
  gap: hasBackButton ? 1 : 2,
  minWidth: 0,
};

const pillLabelStyle = {
  color: "rgba(255,255,255,0.68)",
  fontSize: hasBackButton ? "6px" : "7px",
  lineHeight: 1,
  fontWeight: 1000,
  letterSpacing: "0.25px",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

const navButtonStyle = {
  width: 44,
  height: 44,
  borderRadius: 999,
  border: "1px solid rgba(210,205,255,0.22)",
  background:
    "linear-gradient(135deg, rgba(17,20,58,0.96) 0%, rgba(9,11,36,0.96) 100%)",
  boxShadow:
    "0 10px 22px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.10)",
  color: "#fff",
  cursor: "pointer",
  lineHeight: 1,
  flexShrink: 0,
  display: "grid",
  placeItems: "center",
  transition: "transform 160ms ease, box-shadow 160ms ease, background 160ms ease",
};

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        boxSizing: "border-box",
        padding: "10px 14px 10px 16px",
        margin: 0,
      }}
    >
      {/* LEFT: Back or Menu */}
      <div style={{ display: "flex", alignItems: "center", minWidth: 0, marginLeft: leftShift, flexShrink: 0 }}>
        {hasBackButton && (
          <button
            type="button"
            onClick={onBack}
            aria-label="Zurück"
            style={{
              ...navButtonStyle,
              marginLeft: backShift,
            }}
          >
            <FaChevronLeft aria-hidden="true" size={18} />
          </button>
        )}

        {hasMenuButton && (
          <button
            type="button"
            onClick={onMenu}
            aria-label="Menü öffnen"
            style={navButtonStyle}
          >
            <FaBars aria-hidden="true" size={19} />
          </button>
        )}
      </div>

     {/* CENTER */}
<div
  style={{
    flex: centerTitle ? "1 1 auto" : "0 1 8px",
    minWidth: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  {centerTitle ? (
    <div
      style={{
        fontFamily:
          "'Cooper Hewitt', system-ui, -apple-system, Arial, sans-serif",
        fontStyle: "italic",
        fontWeight: 650,
        fontSize: "22px",
        letterSpacing: "0px",
        textTransform: "uppercase",
        background: "linear-gradient(135deg, #ff007f 0%, #7a2bff 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        whiteSpace: "nowrap",
        padding: "0 10px",
      }}
    >
      VAULTQUEST
    </div>
  ) : null}
</div> 

      {/* RIGHT: Pills */}
      <div style={{ display: "flex", gap: hasBackButton ? "4px" : "5px", flexShrink: 0, marginLeft: hasBackButton ? "10px" : "6px" }}>
        <div
          style={pillBaseStyle}
        >
          <span style={{ ...pillIconStyle, display: "inline-flex", alignItems: "center" }}>
            <CoinIcon size={hasBackButton ? 20 : 22} />
          </span>
          <span style={pillTextWrapStyle}>
            <span style={pillValueStyle}>{displayCoins}</span>
            <span style={pillLabelStyle}>{t("topBar.coins")}</span>
          </span>
        </div>

        <div
          style={{
            ...pillBaseStyle,
            textTransform: "uppercase",
          }}
        >
          <span style={{ ...pillIconStyle, display: "inline-flex", alignItems: "center" }}>
            <TrustIcon size={hasBackButton ? 18 : 20} />
          </span>
          <span style={pillTextWrapStyle}>
            <span style={pillValueStyle}>{profile?.trustLevel ?? 1}</span>
            <span style={pillLabelStyle}>{t("topBar.trust")}</span>
          </span>
        </div>

        <div
          onClick={() => {
            if (notificationsOpen) {
              onCloseNotifications?.();
            } else {
              onOpenNotifications?.();
            }
          }}
          style={{
            ...pillBaseStyle,
            color: unreadNotifications > 0 ? "#ff4d4f" : "#fff",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          <span style={{ ...pillIconStyle, display: "inline-flex", alignItems: "center" }}>
            <style>{`.topbar-message1-icon rect:first-child{fill:transparent;}`}</style>
            <TopBarMessageIcon
              className="topbar-message1-icon"
              aria-hidden="true"
              focusable="false"
              style={{
                width: hasBackButton ? 19 : 21,
                height: hasBackButton ? 19 : 21,
                display: "inline-block",
                verticalAlign: "-0.125em",
                flexShrink: 0,
              }}
            />
          </span>
          <span style={pillTextWrapStyle}>
            <span style={pillValueStyle}>{unreadNotifications}</span>
            <span style={pillLabelStyle}>{t("topBar.messages")}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
